export default __webpack_public_path__ + "static/media/JAKArLogo.c2266c9f.svg";